var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_vm._v(" "+_vm._s(_vm.actionName)+" "),(_vm.isScore)?[_c('code',[_vm._v(_vm._s(_vm.action.args.score.amount))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }